import { Link } from "@lyteflo/components";
import { PortalRoutes } from "@lyteflo/types";
import { HELLO_LYTEFLO_EMAIL, LYTEFLO_WEB_SITE_URL } from "@lyteflo/utils";
import { useTranslation } from "react-i18next";

interface NotFoundProps {
  redirectToPortal?: boolean;
}

export const NotFound = ({ redirectToPortal = false }: NotFoundProps) => {
  const { t } = useTranslation();
  const email = HELLO_LYTEFLO_EMAIL;
  const backLink = redirectToPortal ? PortalRoutes.HOME : LYTEFLO_WEB_SITE_URL;

  return (
    <div className="lf-relative lf-flex lf-h-screen lf-w-screen lf-items-center lf-justify-center lf-bg-[#E2FE65]">
      <div
        className="lf-absolute lf-inset-0 lf-m-auto lf-h-[561px] lf-w-screen lf-max-w-[1373px] lf-bg-cover lf-bg-center"
        style={{
          backgroundImage: `url("/assets/404.jpg")`,
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
        }}
      />
      <div className="lf-relative lf-z-10 lf-max-w-[860px] lf-space-y-8 lf-text-center lf-font-bold lf-uppercase">
        <div className="lf-text-6xl">{t("notFound.title")}</div>
        <div className="lf-text-4xl">{t("notFound.subtitle")}</div>

        <p className="lf-px-6 lf-text-lg">{t("notFound.description")}</p>
        <Link href={backLink} className="lf-block" variant="gray">
          <span className="lf-text-default lf-underline lf-text-lg">
            {t("notFound.cta")}
          </span>
        </Link>
        <div>
          <span className="lf-text-default lf-mr-2 lf-text-lg">
            {t("notFound.contact")}
          </span>
          <Link
            href={`mailto:${email}`}
            className="lf-inline-block"
            variant="gray"
          >
            <span className="lf-text-default lf-underline lf-text-lg">
              {HELLO_LYTEFLO_EMAIL}
            </span>
          </Link>
        </div>
      </div>
    </div>
  );
};
